export default "/assets/images/awards-img-01-lg.c2b3f7964914be61.svg";